import { render, staticRenderFns } from "./PatientData.vue?vue&type=template&id=09fb7cd2&"
import script from "./PatientData.vue?vue&type=script&lang=js&"
export * from "./PatientData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports